import { render, staticRenderFns } from "./categoryManage.vue?vue&type=template&id=30770bb9&scoped=true"
import script from "./categoryManage.vue?vue&type=script&lang=js"
export * from "./categoryManage.vue?vue&type=script&lang=js"
import style0 from "./categoryManage.vue?vue&type=style&index=0&id=30770bb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30770bb9",
  null
  
)

export default component.exports